import type { FaireProductEntity } from "../../entity_types/product";

export const p_ac7nh5eym2: FaireProductEntity = {
  token: "p_ac7nh5eym2",
  type: "product",
  name: "Mini Candles | 2 oz",
  brandName: "Benjamin Soap Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/9bc69ac2abc5ee7a6dfd87e402749d0395660b8bb08488bed5a7066401c362b5.png",
  priceDollars: 4.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/6a778054018fc5ed966fe68ad828a8108e02f2010005663181e0c3f81bf1a1fa.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
